export default __webpack_public_path__ + "static/media/ukrainego-mobile-2.ae2f517b.png";